import { TaxonomyFieldName } from 'v2/core/entities/fields';
import { UUID } from 'v2/core/entities/uuid';
import { EmptyWhereClause, OperationType, WhereClause } from './whereClause';
import { isEqual } from 'lodash';

const nonLabelNodeWhereClauseGenerator = (values: UUID[]): WhereClause[] => {
  return [
    {
      filter: {
        labelHierarchyFilter: {
          nodeIDs: values,
        },
      },
    },
  ];
};

const entityNodeWhereClauseGenerator = (values: UUID[]): WhereClause[] => {
  return [
    {
      filter: {
        entityFilter: {
          entities: values.map((entityID) => ({ entityID })),
        },
      },
    },
  ];
};

const reasonNodeWhereClauseGenerator = (values: UUID[]): WhereClause[] => {
  return [
    {
      filter: {
        reasonFilter: {
          reasonIDs: values,
        },
      },
    },
  ];
};

type whereClauseGenerator = (values: UUID[]) => WhereClause[];

const fieldSpecificWhereClauseGenerator: Record<
  TaxonomyFieldName,
  whereClauseGenerator
> = {
  Theme: nonLabelNodeWhereClauseGenerator,
  Reason: reasonNodeWhereClauseGenerator,
  Entity: entityNodeWhereClauseGenerator,
};
const createWhereClauseFromPredictionFilters = (
  fieldName: TaxonomyFieldName,
  values: UUID[],
) => {
  return fieldSpecificWhereClauseGenerator[fieldName](values);
};

const combineWhereClauses = (
  clause1: WhereClause,
  clause2: WhereClause,
  conjunction: OperationType,
): WhereClause => {
  const isEmptyClause1 = isEqual(clause1, EmptyWhereClause);
  const isEmptyClause2 = isEqual(clause2, EmptyWhereClause);

  if (isEmptyClause1 && isEmptyClause2) {
    return EmptyWhereClause;
  }

  if (isEmptyClause1 && !isEmptyClause2) {
    return clause2;
  }

  if (!isEmptyClause1 && isEmptyClause2) {
    return clause1;
  }

  return {
    op: {
      type: conjunction,
      params: [clause1, clause2],
    },
  };
};
// take a where clause and
// join its root with an AND and another clause
// of OR of `node` with `nodeValues`
const doGlobalANDForNode = (
  fieldName: TaxonomyFieldName,
  nodeValues: UUID[],
  where: WhereClause,
): WhereClause => {
  // change this
  const nodesWhereClauses = createWhereClauseFromPredictionFilters(
    fieldName,
    nodeValues,
  );
  return {
    op: {
      type: OperationType.AND,
      params: [
        where,
        {
          op: {
            type: OperationType.OR,
            params: [...nodesWhereClauses],
          },
        },
      ],
    },
  };
};

export { doGlobalANDForNode, combineWhereClauses };
